import React , {Component} from 'react';
import * as axios from "axios/index";
import * as vars from './../Vars';
import loginBoxIcon from './../../assets/images/icons/login-box.svg';
import smartPhoneIcon from './../../assets/images/icons/smartphone.svg';
import faceIcon from './../../assets/images/icons/face.svg';
import userIcon from './../../assets/images/icons/user.svg';
import { Modal } from 'react-bootstrap';
import validator from 'validator';

class LoginRegister extends Component{

    constructor(props){

        super(props)
        this.state = {
            phoneModal : false,
            registerModal : false,
            verificationCodeModal : false,

            inPageLoading : false ,

            errors : {} ,
            fields : {
                phone : "" ,
                code : "" ,
                name : "" ,
                gender : "female" ,

            } ,

            registerError : null
        }

    }


    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    messageModalHandler(){
        this.props.loginModalShowHandler()
    }

    phoneModalRequestHandler(){
        this.messageModalHandler()

        setTimeout(
            function() {
                this.setState({
                    phoneModal : true
                })
            }
                .bind(this),
            500
        )
    }

    phoneModalHideHandler(){
        this.setState({
            phoneModal : false
        })
    }

    phoneModalSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let phoneValid = true
        if ( fields.phone === null || validator.isEmpty(fields.phone))
        {
            phoneValid = false;
            errors['phone'] = 'شماره موبایل خود را وارد کنید';
        }
        else if(! validator.isLength(fields.phone , { min : 11 , max : 11}))
        {
            phoneValid = false;
            errors['phone'] = 'موبایل خود را صحیح وارد کنید';
        }
        else if(! validator.isMobilePhone(fields.phone) )
        {
            phoneValid = false;
            errors['phone'] = 'موبایل خود را صحیح وارد کنید';
        }

        if (phoneValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }

        this.setState({
            inPageLoading : true
        })
        let data = new FormData()
        data.append('phone' , this.state.fields.phone )
        axios.post(vars.Url +'api/v1/login' , data , {
            params : {
            }

        } )
        .then(response => {
            this.setState({
                inPageLoading : false ,
                phoneModal : false ,

            })

            setTimeout(
                function() {
                    this.setState({
                        verificationCodeModal : true ,
                    })
                }
                    .bind(this),
                500
            )
        })
        .catch(error => {
            this.setState({
                inPageLoading : false ,
                phoneModal : false ,
            })
            setTimeout(
                function() {
                    this.setState({
                        registerModal : true ,
                    })
                }
                    .bind(this),
                500
            )
        })
    }

    verificationCodeModalHideHandler(){
        this.setState({
            verificationCodeModal : false ,
        })
    }
    verificationCodeSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let codeValid = true
        if ( fields.code === null || validator.isEmpty(fields.code))
        {
            codeValid = false;
            errors['code'] = 'کد را وارد کنید';
        }
        else if(! validator.isLength(fields.code , { min : 4 , max : 4}))
        {
            codeValid = false;
            errors['code'] = 'کد را صحیح وارد کنید';
        }

        if (codeValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }

        this.setState({
            inPageLoading : true
        })
        let data = new FormData()
        data.append('phone' , this.state.fields.phone )
        data.append('code' , this.state.fields.code )
        axios.post(vars.Url +'api/v1/authentication' , data , {
            params : {
            }

        } )
            .then(response => {

                this.setState({
                    inPageLoading : false ,
                    verificationCodeModal:false
                })

                let data = response.data.data
                localStorage.setItem("api_token" , data.user.api_token)
                localStorage.setItem("gender" , data.user.gender)
                localStorage.setItem("name" , data.user.name)
                localStorage.setItem("phone" , data.user.phone)
                localStorage.setItem("unreadMessage" , data.user.unreadMessage)
                localStorage.setItem("wallet" , data.user.wallet)
                this.props.userIsLoginHandler()
                  // console.log(response)
            })
            .catch(error => {
                let errors = {}
                errors['code'] = 'کد را صحیح وارد کنید';
                this.setState({
                    inPageLoading : false ,
                    errors : errors
                })
                // console.log(error.message)
            })
    }
    changePhoneHandler(){
        this.setState({
            verificationCodeModal : false ,
        })
        setTimeout(
            function() {
                this.setState({
                    phoneModal : true ,
                })
            }
                .bind(this),
            500
        )
    }


    registerModalHideHandler(){
        this.setState({
            registerModal : false ,
        })
    }
    registerSubmitHandler(){

        let { fields } = this.state
        let errors = {}
        let formValid = true
        if ( fields.phone === null || validator.isEmpty(fields.phone))
        {
            formValid = false;
            errors['phone'] = 'شماره موبایل خود را وارد کنید';
        }
        else if(! validator.isLength(fields.phone , { min : 11 , max : 11}))
        {
            formValid = false;
            errors['phone'] = 'موبایل خود را صحیح وارد کنید';
        }
        else if(! validator.isMobilePhone(fields.phone) )
        {
            formValid = false;
            errors['phone'] = 'موبایل خود را صحیح وارد کنید';
        }

        if ( fields.name === null || validator.isEmpty(fields.name))
        {
            formValid = false;
            errors['name'] = 'نام خود را وارد کنید';
        }


        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }

        this.setState({
            inPageLoading : true
        })
        let data = new FormData()
        data.append('phone' , this.state.fields.phone )
        data.append('name' , this.state.fields.name )
        data.append('gender' , this.state.fields.gender )
        axios.post(vars.Url +'api/v1/register' , data , {
            params : {
            }

        } )
        .then(response => {
            this.setState({
                inPageLoading : false ,
                registerModal : false ,

            })

            setTimeout(
                function() {
                    this.setState({
                        verificationCodeModal : true ,
                    })
                }
                    .bind(this),
                500
            )
        })
        .catch(error => {
            this.setState({
                inPageLoading : false ,
                registerError : "اطلاعات خواسته شده را وارد کنید!" ,
            })
        })

    }

    render(){
        const {errors} = this.state;
        return(
            <div>

                <Modal
                    show={this.props.loginModalShow}
                    onHide={this.messageModalHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>

                        <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                            <div className="content-container">
                                <div className="text-center mb-3">
                                    <i className="fas fa-circle-notch fa-spin item-icon" />
                                </div>
                                <div className="title">
                                    لطفا شکیبا باشید
                                </div>
                            </div>
                        </div>

                        <div className="title">
                            <img src={loginBoxIcon} alt="timer" className="item-icon" />
                            عضویت / ورود
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                برای ادامه باید عضو اپلیکیشن شوید،
                                <br />
                                یا اگر عضو هستید، با شماره موبایل خود وارد شوید
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.phoneModalRequestHandler.bind(this)}>
                                عضویت / ورود
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>


                <Modal
                    show={this.state.phoneModal}
                    onHide={this.phoneModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            عضویت / ورود
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                لطفا اطلاعات خواسته شده را وارد کنید
                                <br />
                            </div>
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                                <input
                                    type="number"
                                    className={["form-control form-control-custom-1" , errors['phone'] ? 'is-invalid' : ''].join(' ')}
                                    name="phone"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder="شماره همراه"
                                    value={this.state.fields.phone}  />
                                <span className={["invalid-feedback" ,  errors['phone'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['phone'] }</span>

                                <img src={smartPhoneIcon} alt="smart-phone" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.phoneModalSubmitHandler.bind(this)}>
                                ادامه
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>




                <Modal
                    show={this.state.verificationCodeModal}
                    onHide={this.verificationCodeModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            کد تایید
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                کد تایید به شماره.
                                {this.state.fields.phone}
                                ارسال شد.
                                آن را وارد کنید
                                <br />
                            </div>
                        </div>
                        <div  className="mt-3">
                            <div className="form-group">
                                <input
                                    type="number"
                                    className={["form-control form-control-custom-1 text-center" , errors['code'] ? 'is-invalid' : ''].join(' ')}
                                    name="code"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.code}  />
                                <span className={["invalid-feedback" ,  errors['code'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['code'] }</span>

                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.verificationCodeSubmitHandler.bind(this)}>
                                تایید
                            </button>
                        </div>
                        <div className="mt-4">
                            <div className="row justify-content-between">
                                <div className="col-auto">
                                    <div className="content-custom-1">
                                        شماره موبایل اشتباه است؟
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="content-custom-2" onClick={this.changePhoneHandler.bind(this)}>
                                        اصلاح شماره
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>




                <Modal
                    show={this.state.registerModal}
                    onHide={this.registerModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            عضویت
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                لطفا اطلاعات خواسته شده را وارد کنید
                            </div>
                            {
                                this.state.registerError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.registerError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                                <input
                                    type="text"
                                    className={["form-control form-control-custom-1" , errors['name'] ? 'is-invalid' : ''].join(' ')}
                                    name="name"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder="نام و نام خانوادگی"
                                    value={this.state.fields.name}  />
                                <span className={["invalid-feedback" ,  errors['name'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['name'] }</span>
                                <img src={faceIcon} alt="name" className="item-icon" />
                            </div>


                            <div className="form-group form-group-custom-1">
                                <select
                                    name="gender"
                                    className={["form-control form-control-custom-1" , errors['gender'] ? 'is-invalid' : ''].join(' ')}
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.gender}>
                                    <option value="male" >مرد</option>
                                    <option value="female">زن</option>
                                    <option value="other">سایر</option>
                                </select>
                                <span className={["invalid-feedback" ,  errors['gender'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['gender'] }</span>
                                <img src={userIcon} alt="gender" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.registerSubmitHandler.bind(this)}>
                                ادامه
                            </button>
                        </div>

                    </Modal.Body>
                </Modal>

            </div>
        )
    }
}

export default LoginRegister